import * as React from 'react';
import { Button } from '../../../components/Button/Button';
import { Link } from '../../../components/Link';
import { getQueryParams } from '../../../helpers/IsomorphicHelpers';
import { __ } from '../../../helpers/TranslationService';

interface IProps {
    url: string;
    disabled?: boolean;
}

export function RequestFormBtn({ url, disabled }: IProps) {
    const { promotionCode } = getQueryParams();

    let promotionCodeString = '';
    if (promotionCode) {
        promotionCodeString = '?promotionCode=' + promotionCode;
    }

    const pathname = `${url}${promotionCodeString}`;
    const link = disabled ? null : pathname;
    return (
        <Link href={link} mask={true}>
            <Button fullWidth withArrow disabled={disabled} testSelectorName="submitRequest">
                {__('continue', 'dreamlines')}
            </Button>
        </Link>
    );
}
